import { render } from "./AddPersonAdmin.vue?vue&type=template&id=ca9a1a82"
import script from "./AddPersonAdmin.vue?vue&type=script&lang=js"
export * from "./AddPersonAdmin.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\JCXS\\CAAMSNG\\frontend-caams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__